import "./style.scss";
import domReady from "@wordpress/dom-ready";

function Prices() {
  const prices = document.querySelectorAll(".prices");
  if (!prices.length) return null;

  prices.forEach(function (priceBox) {
    const tabs = priceBox.querySelectorAll(".tabs .tab");

    tabs.forEach(function (tab) {
      //console.log("here");
      tab.addEventListener("click", () => {
        // remove active class
        priceBox.querySelectorAll(".tabs > .active").forEach((tab) => tab.classList.remove("active"));
        tab.classList.add("active");

        let tabId = tab.getAttribute("data-price-column");
        //1.First check if an already tab is active
        const alreadyActiveBox = priceBox.querySelectorAll(".show-column");

        if (alreadyActiveBox.length) {
          alreadyActiveBox.forEach(function (box) {
            box.classList.remove("show-column");
          });
        }

        //2. Fetch the ones, which have been tabed and should be active
        const activeTab = priceBox.querySelectorAll(tabId);
        activeTab.forEach(function (active) {
          active.classList.add("show-column");
        });
      });
    });
  });
}

domReady(Prices);
